<template>

    <div id="TimeTable" :class="{ 'active': active }">

        <h2>Agenda</h2>

        <div v-for="locations in activitiesByLocation" class="activity-location-group">
            <h3 v-if="locations.scene" :class="createSceneClass(locations.scene)">{{ locations.scene }}</h3>

            <div v-for="activity in locations.activities" class="activity" :class="{ 'active': activity.active }">
                <div>{{ activity.startTimeString }} - {{ activity.endTimeString }}</div>
                <div class="divider" :class="createSceneClass(locations.scene)"></div>
                <div v-html="activity.title"></div>

            </div>

        </div>


    </div>

</template>
<script>

export default {
    props: ["active", "items"],
    data() {
        return {
            isOpen: false,

        }
    },

    mounted() {

    },

    methods: {

        createSceneClass(str) {
            return 'scene-' + str.split(" ").join("-").toLowerCase();
        }
    },

    computed: {
        activitiesByLocation() {

            const locationGroups = [];
            let currentGroup = null;

            this.items.forEach((item, index) => {
                // If current group is null or the sceneId changes, start a new group
                if (!currentGroup || currentGroup.scene !== item.scene) {
                    currentGroup = {
                        scene: item.scene,

                        activities: []
                    };
                    locationGroups.push(currentGroup); // Push the new group to result
                }
                // Add the current item to the current group
                currentGroup.activities.push(item);
            });

            return locationGroups;
        },

    }
}
</script>
<style lang="scss" scoped>
$padding: 28px;

#TimeTable {
    position: absolute;
    text-align: left;
    height: 950px;
    width: 450px;
    bottom: 0px;
    left: 20px;
    padding: $padding;
    z-index: 1;
    background-color: var(--light-grey);
    border-radius: 20px 20px 0 0;
    transform: translateY(100%);
    transition: transform 0.5s var(--expo-easeinout);
    color: var(--md-black);

    // -webkit-box-shadow: 9px 10px 5px 0px rgba(0, 0, 0, 0.1);
    // -moz-box-shadow: 9px 10px 5px 0px rgba(0, 0, 0, 0.1);
    box-shadow: 3px 0px 50px 0px rgba(0, 0, 0, 0.1);

    &.active {
        transform: translateY(0);
    }



    h2 {
        font-family: 'Arla Strong';
        font-size: 40px;
        margin-bottom: 0.7em;
    }

    .activity-location-group {


        h3 {
            font-size: 11px;
            margin: 0.8em 0;
            display: flex;
            width: 88px;
            height: 20px;
            justify-content: center;
            align-items: center;
            border-radius: 20px;


        }

        .activity {
            display: flex;
            align-items: center;
            gap: 25px;
            height: 28px;
            margin: auto calc(0px - $padding);
            padding: 0 $padding;


            .divider {
                width: 2px;
                height: 28px;
            }

            &.active {
                background-color: #fff9;
            }
        }

    }


    .scene-parking-lot{
        background-color: var(--mid-green);
        color: #fff;
    }

    .scene-milk-reception {
        background-color: var(--baby-blue);
        color: var(--petrol);
    }

    .scene-production {
        background-color: var(--yellow);
        color: var(--yellow-brown);
    }

    .scene-warehouse {
        background-color: var(--rusty-red);
        color: #fff;
    }

    .scene- {
        background-color: #fff;

    }


}
</style>